import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles/product-details-quantity-selector.scss';
import { priceFormat } from '../../helper';
import AgeValidWrapper from '../age-valid-wrapper/age-valid-wrapper';
import SecurityPaymentIcons from '../security-icons';

const ProductDetailsQuantitySelector = (props) => {
    const {
        productPrice,
        productAgeValid,
        addingProductToCart,
        dataExtraType,
    } = props;
    const [quantity, setQuantity] = useState(1);
    const onPressMinus = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };
    const onChangeQuantity = (e) => {
        if (quantity !== e.target.value && parseInt(e.target.value, 10) > 0) {
            setQuantity(parseInt(e.target.value, 10));
        }
    };
    const onPressPlus = () => {
        setQuantity(quantity + 1);
    };
    const addProductToCart = () => props.onAddProductToCart(quantity);

    return (
        <div className={styles.buyPanel}>
            <div className={`${styles.buyPanelOptions}`}>
                <div className={`pull-right ${styles.inlineBlock}`}>
                    <div className={`text-center ${styles.wishCart}`}>
                        <div className={`text-right ${styles.innerAddWish}`}>
                            <a href="" className={styles.addWishList}>
                                <span className={styles.addWishListButton}>
                                    <FormattedMessage
                                        id="add-to-wish-list"
                                        defaultMessage="Add to Wish List"
                                    />
                                </span>
                                <i className="pe-7f-like pe-va" />
                            </a>
                            <a
                                href=""
                                className={styles.addToCart}
                            >
                                <span className={styles.addToCartButton}>
                                    <FormattedMessage
                                        id="add-to-cart"
                                        defaultMessage="Add to Cart"
                                    />
                                </span>
                                <i className="pe-va pe-7f-cart" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className={styles.quantityProd}>
                    <div className={styles.quantityProdOptions}>
                        <FormattedMessage
                            id="quantity"
                            defaultMessage="Quantity"
                        />
                    </div>
                    <div className={styles.selectorQuantity}>
                        <button
                            className={styles.minus}
                            type="button"
                            disabled={quantity <= 1 || (props.dataExtraType && props.dataExtraType.length > 0) ? 'disabled' : ''}
                            onClick={onPressMinus}
                        >
                            -
                        </button>
                        <span className={styles.quantityContainer}>
                            <input
                                title="Quantity"
                                type="text"
                                value={quantity}
                                onChange={onChangeQuantity}
                                className="form-control quantity"
                                disabled={props.dataExtraType && props.dataExtraType.length > 0 ? 'disabled' : ''}
                            />
                        </span>
                        <button className={styles.plus} type="button" disabled={props.dataExtraType && props.dataExtraType.length > 0 ? 'disabled' : ''} onClick={onPressPlus}>+</button>
                    </div>
                </div>
                <div className={styles.totalPrice}>
                    <div className={styles.totalPriceTitle}>
                        <span>
                            <FormattedMessage
                                id="total-price"
                                defaultMessage="Total price"
                            />
                        </span>
                    </div>
                    <span className={styles.totalPriceTitleValue}>
                        {priceFormat.format(productPrice * quantity)}
                    </span>
                </div>
                <div className={styles.actions}>
                    <div className={styles.addCartAction}>
                        <div className={styles.addCartActionInner}>
                            <AgeValidWrapper productAgeValid={productAgeValid}>
                                <button
                                    type="button"
                                    disabled={addingProductToCart}
                                    className={!addingProductToCart
                                        ? styles.addCartExpandedButton
                                        : styles.disableAddCartExpandedButton}
                                    onClick={addProductToCart}
                                >
                                    <i className="pe-va pe-7f-cart" />
                                    <FormattedMessage
                                        id="add-to-cart"
                                        defaultMessage="Add to Cart"
                                    />
                                </button>
                            </AgeValidWrapper>
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hidden-xs">
                        <SecurityPaymentIcons />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetailsQuantitySelector;



/** WEBPACK FOOTER **
 ** ./src/components/product/product-details-quantity-selector.js
 **/